import React from 'react';
import Modal from '@material-ui/core/Modal';
import {
  Box,
  Button,
  makeStyles,
  TextField,
  Typography
} from '@material-ui/core';
import { TransactionPayment } from 'src/types';

const useStyles = makeStyles((theme) => ({
  body: {
    position: 'absolute',
    width: '90%',
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    borderRadius: 8,
    top: '20%',
    [theme.breakpoints.down('xs')]: {
      top: '10%',
      padding: theme.spacing(2),
    },
    boxSizing: 'border-box',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  footer: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  formContainer: {
    marginTop: theme.spacing(2),
  },
  footerBtn: {
    minWidth: 120,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
    padding: theme.spacing(1),
  },
}));

interface Props {
  visible: boolean;
  onHandleClose: () => void;
  data?: TransactionPayment;
  title?: string;
  fieldName?: string;
  loading?: boolean;
  placeholder?: string;
  holdReason: string | undefined;
  setHoldReason: (v: string | undefined) => void;
  onSubmitHoldReason: (v: string | undefined) => void;
}

export const HoldModal = ({
  visible,
  onHandleClose,
  title,
  fieldName,
  placeholder,
  holdReason,
  setHoldReason,
  onSubmitHoldReason
}: Props) => {
  const classes = useStyles();

  const resetState = () => {
    setHoldReason(undefined);
  };

  const onCloseInternal = () => {
    resetState();
    onHandleClose();
  };

  return (
    <Modal
      disableBackdropClick
      open={visible}
      onClose={onCloseInternal}
      className={classes.modal}
    >
      <div className={classes.body}>
        {title && (
          <div className={classes.titleContainer}>
            <Typography variant="h5" color="textPrimary">
              {title}
            </Typography>
          </div>
        )}

        <div className={classes.formContainer}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label={fieldName}
            name={`${fieldName}`}
            onChange={(e) => setHoldReason(e.target.value || '')}
            value={holdReason || ''}
            variant="outlined"
            placeholder={placeholder}
          />
        </div>

        <Box className={classes.footer}>
          <Button
            onClick={onCloseInternal}
            color="primary"
            variant="outlined"
            className={classes.footerBtn}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              onSubmitHoldReason(holdReason);
              onCloseInternal();
            }}
            color="primary"
            variant="contained"
            className={classes.footerBtn}
            disabled={!holdReason || holdReason.trim() === ''}
          >
            Add hold reason
          </Button>
        </Box>
      </div>
    </Modal>
  );
};
